import React from 'react'
import styled from 'styled-components'
import social from '../../assets/images/new/social.png'
import { useTranslation } from 'react-i18next'

const Wrapper = styled.footer`
  background-color: ${props => props.theme.cWhite};
  border-top: 1px solid #d8d8d8;
  min-height: 57px;
  width: 100%;
`
const InnerNav = styled.nav`
  color: ${props => props.theme.cGreySub};
  display: grid;
  font-size: 13px;
  font-weight: 400;
  grid-auto-columns: minmax(0, 1fr);
  padding: 10px 20px 5px;

  @media (min-width: ${p => p.theme.mobileLargeSize}) {
    grid-template-columns: auto 140px;
    height: 100%;
    margin: auto;
    padding: 0;
    max-width: 945px;
  }

  > ul, > ul > li {
    list-style: none;
    margin: 0;
    padding: 0;
  }
`

const LeftListBlock = styled.ul`
  display: flex;
  flex-flow: column nowrap;
  line-height: 1.4;
  a {
    color: ${p => p.theme.cGreyText};
    &:hover {
      color: ${p => p.theme.cBlue};
    }
  }
  > li {
    &:not(:last-child) {
      padding-right: ${p => p.theme.s};
      &:first-child {
        padding-right: ${p => p.theme.m};
      }

    }
  }
  &>div:nth-child(3), &>div:nth-child(4){
    display: none;
  }
  @media (min-width: ${props => props.theme.mediaTriggerWidth}) {
    flex-flow: row nowrap;
    &>div{
      margin-right: 10px;
    }
    &>div:nth-child(3), &>div:nth-child(4){
      display: block;
    }
    align-items: center;
  }
`
const RightListBlock = styled.ul`
  display: flex;
  align-self: center;
  a {
  transition: opacity .2s ease;
  display: block;
    &:hover {
      opacity: .8;
    }
    &:focus {
      border-top: 3px ${p => p.theme.cBlue} solid;
    }
    &:active {
      border-color: ${p => p.theme.cOrange};
    }
  }
 `
const Icon = styled.div`
  cursor: pointer;
  display: inline-block;
  background-image: url(${social});
  width: 28px;
  height: 28px;
  background-color: transparent;
  background-repeat: no-repeat;
`
const Vk = styled(Icon)`
  background-position: 0 0;
`
const Fb = styled(Icon)`
  background-position: -28px 0px;
`
const Inst = styled(Icon)`
  background-position: -56px 0;
`
const Yt = styled(Icon)`
  background-position: -84px 0;
`
const Tw = styled(Icon)`
  background-position: -112px 0;
`

const Footer = () => {
  const { t } = useTranslation()
  return (
  <Wrapper id="app-footer">
    <InnerNav>
      <LeftListBlock>
        <li>
          {t('© 2012-{{year}} Sport Vokrug.', { year: new Date().getFullYear() })}
        </li>
        <li>
          <a href={'/terms/'}>{t('Terms')}</a>
        </li>
        <li>
          <a href={'/contract-agent/'}>{t('Agency agreement')}</a>
        </li>
        <li>
          <a href={'/services/'}>{t('Services')}</a>
        </li>
        <li>
          <a href={'/info/'}>{t('About us')}</a>
        </li>
        <li>
          <a href={'/info/#mincifry'}>{t('Ministry of Digital Development information')}</a>
        </li>
        <li>
          <a href={'/projects/'}>{t('Our projects')}</a>
        </li>
      </LeftListBlock>
      <RightListBlock>
        <li>
          <a href={'https://vk.com/sportvokrug'} target={'_blank'} rel="noreferrer">
            <Vk />
          </a>
        </li>
        {/*
          <li>
            <a href={'https://www.facebook.com/sportvokrug'} target={'_blank'} rel="noreferrer">
              <Fb />
            </a>
          </li>
          <li>
            <a href={'https://instagram.com/sportvokrug'} target={'_blank'} rel="noreferrer">
              <Inst />
            </a>
          </li>
        */}
        <li>
          <a
            href={'https://www.youtube.com/channel/UCwbvilx8vQ2Op4CpDRCujfA/videos'}
            target={'_blank'}
            rel="noreferrer"
          >
            <Yt />
          </a>
        </li>
        <li>
          <a href={'https://twitter.com/Sport_Vokrug'} target={'_blank'} rel="noreferrer">
            <Tw />
          </a>
        </li>
      </RightListBlock>
    </InnerNav>
  </Wrapper>
  )
}

export default Footer
